const api = {
  // BASE_API_URL: 'http://127.0.0.1:8000/api/',
  // BASE_API_URL: 'https://api-dev.sadi.ba/api/', // DEV
  BASE_API_URL: 'https://api.sadi.ba/api/', // PROD
  IS_PRODUCTION: true,
}

export default api
